import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertSuccessTransparentIcon extends BaseIcon {
    getChildren = () => [
        <>
            <path d="M87,13,73.583,32,64,24" transform="translate(-53 -0.481)" fill="none" stroke="#56b40a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <g fill="none" stroke="#56b40a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                <circle cx="22.5" cy="22.5" r="22.5" stroke="none"/>
                <circle cx="22.5" cy="22.5" r="21.5" fill="none"/>
            </g>
        </>
    ]
    getViewBox = () => '0 0 45 45'
}
